import { useNavigate } from "react-router-dom";

import ChevronLeft from "atoms/icon/icons/chevron_left.svg";

type Props = {
  className?: string;
  /** Explicit previous route; when provided, back button will navigate here */
  prev?: string;
};

/**
 * Placeholder component to maintain header spacing when back button is hidden
 */
export const OnboardingBackButtonPlaceholder = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <div className={`flex items-center px-3 pb-0 pt-4 ${className || ""}`} />
  );
};

export const OnboardingBackButton = ({ className, prev }: Props) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (prev) {
      navigate(prev);
      return;
    }
    navigate(-1);
  };

  return (
    <div className={`flex items-center px-3 pb-0 pt-4 ${className || ""}`}>
      <button
        onClick={handleClick}
        className="flex h-11 w-11 items-center justify-center rounded-full active:bg-two"
        type="button"
        aria-label="Go back"
      >
        <ChevronLeft className="h-6 w-6" fill="rgb(9 31 36)" />
      </button>
    </div>
  );
};

export default OnboardingBackButton;
